import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  if (post === null) return <div className="p-20 text-center" data-testid="loading">Loading…</div>;
  if (post === false) return (
    <div className="p-20 text-center" data-testid="not-found">
      <p className="mb-6">Article not found.</p>
      <Link to="/blog" className="btn-secondary">Back to Journal</Link>
    </div>
  );

  return (
    <article data-testid="blog-post-page" className="px-6 md:px-12 lg:px-20 pt-24 pb-24 max-w-4xl mx-auto">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm mb-10 opacity-70 hover:opacity-100" data-testid="back-to-blog">
        <ArrowLeft size={14} /> Back to Journal
      </Link>
      <p className="overline mb-6">{post.author}</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-tight mb-10">{post.title}</h1>
      <img src={post.image} alt={post.title} className="w-full h-[60vh] object-cover mb-12" />
      <div className="prose-lg max-w-none">
        {post.content.split("\n\n").map((para, i) => (
          <p key={i} className="text-lg leading-relaxed mb-6" style={{ color: "var(--ayu-body)" }}>{para}</p>
        ))}
      </div>
    </article>
  );
};

export default BlogPost;
